module.exports = __webpack_public_path__ + "img/7.4.0-5-mobile.612fc995.png";